import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ModulesCacheState {
  [key: string]: any[]; 
}

const initialState: ModulesCacheState = {};

const modulesCacheSlice = createSlice({
  name: "modulesCache",
  initialState,
  reducers: {
    setModulesCache: (
      state,
      action: PayloadAction<{ key: string; data: any[] }>
    ) => {
      state[action.payload.key] = action.payload.data;
    },
  },
});

export const { setModulesCache } = modulesCacheSlice.actions;
export default modulesCacheSlice.reducer;
